import { TranslateService } from '@ngx-translate/core';
import { WorkflowsManagementPermissions } from '../../permissions';
import { UserContext } from '../../../../common';
import { MenuItem } from '../../../../views/layout/sidebar/menu.model';

export const getWorkflowsMenu: (userContext?: UserContext, translate?: TranslateService) => MenuItem[] = (
  userContext?: UserContext,
  translate?: TranslateService
) => {
  const hasAccessToWorkflows = userContext?.hasPermission(WorkflowsManagementPermissions.Workflows.ReadAll);
  return [
    {
      id: 15,
      label: translate ? translate.instant('MENUS.WORKFLOW') : 'Workflow',
      isHidden: !hasAccessToWorkflows,
      icon: 'pi pi-chart-line',
      expanded: true,
      link: `workflows`
    }
  ];
};
